import {Store} from '@reatom/core'
import {createPrimitiveAtom} from '@reatom/core/primitives'
import {getTime, hoursToMilliseconds} from 'date-fns'
import {indexBy} from 'ramda'
import {getApi} from '../../api'

let lastInitTimestamp: number | null

export interface TswNameData {
  id: string
  title: string
  color: string
}

export const tswNameColorsAtom = createPrimitiveAtom<
  Record<string, TswNameData>
  >({})

export async function updateTswNameColorsAtom({dispatch}: Store) {
  if (
    lastInitTimestamp &&
    lastInitTimestamp + hoursToMilliseconds(2) > getTime(new Date())
  ) {
    return
  }
  const data = await getApi().procurement.getTswNameMap()
  const record = indexBy(x => x.id, data)
  dispatch(tswNameColorsAtom.set(record))
  lastInitTimestamp = getTime(new Date())
  return record
}